export const anes = {
  id: "anes",
  name: {
    ru: "Анес Назерке Мендуллаевна",
    kz: "Анес Назерке Мендуллаевна"
  },
  position: {
    ru: "Медицинская сестра общей практики, высшая категория",
    kz: "Жалпы тәжірибе мейіргері, жоғары санат"
  },
  department: "medical-staff",
  image: "/team_photoes/new/Назерке Мендуллаевна.svg", // Placeholder, update if photo is added
  experience: {
    ru: "12 лет",
    kz: "12 жыл"
  },
  education: {
    ru: `2010–2013 — Медицинский колледж «Даналык», г. Астана, «Лечебное дело» (с отличием)
2013–2017 — Казахский университет экономики, финансов и международной торговли, специальность «Таможенное дело»
2024–2027 (в процессе) — Медицинский университет Астана, «Бакалавр сестринского дела»`,
    kz: `2010–2013 — Астана қаласы, «Даналық» медициналық колледжі, «Емдеу ісі» (үздік дипломмен)
2013–2017 — Қазақ экономика, қаржы және халықаралық сауда университеті, «Кеден ісі» мамандығы
2024–2027 (оқуда) — Астана медицина университеті, «Мейіргер ісі бакалавры»`
  },
  certificates: {
    ru: `Повышение квалификации: BLS, ACLS, сестринские технологии, массаж, антидопинговая подготовка
2020 — Присвоена первая квалификационная категория по специальности «Сестринское дело»
2024 — Сертификаты по современным технологиям в сестринском деле, спортивной реабилитации, допинг-контролю`,
    kz: `Біліктілігін арттыру: BLS, ACLS, мейіргер ісі технологиялары, массаж, допингке қарсы дайындық
2020 — «Мейіргер ісі» мамандығы бойынша бірінші біліктілік санаты берілді
2024 — Мейіргер ісіндегі заманауи технологиялар, спорттық оңалту, допинг-бақылау бойынша сертификаттар`
  },
  work: {
    ru: `• 2013–2015 — Медсестра отделения интервенционной кардиологии, АО «Национальный научный кардиохирургический центр»
• 2015–2025 — Медицинская сестра, РГКП «Центр олимпийской подготовки Астана»
• 2025 — по настоящее время — ГККП "Спортивный медицинский центр города Астаны"`,
    kz: `• 2013–2015 — Интервенциялық кардиология бөлімшесінің мейіргері, «Ұлттық ғылыми кардиохирургия орталығы» АҚ
• 2015–2025 — Мейіргер, «Астана олимпиадалық даярлау орталығы» РМҚК
• 2025 — қазіргі уақытқа дейін — Астана қаласының «Спорттық медицина орталығы» МКҚК`
  }
}; 